import React, { useState } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

import { Alert, Avatar, Paper, Snackbar, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

import CustomerUser from "../../components/auth/CustomerUser";
import OTP from "../../components/auth/OTP";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function Login() {
  const [state, setState] = useState(0);
  const [verification, setVerification] = useState("");
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message || null);
  const [alertOpen, setAlertOpen] = useState(
    location?.state?.alertOpen || false
  );

  const handleAlertClose = () => {
    setAlertOpen(false);
    setMessage(null);
  };

  if (state === 0) {
    return (
      <React.Fragment>
        {message && (
          <Snackbar
            open={alertOpen}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleAlertClose}
          >
            <Alert severity="success">{message}</Alert>
          </Snackbar>
        )}

        <Wrapper>
          <Helmet title="Alpha Plus" />
          <BigAvatar alt="alpha_plus" src="/static/img/avatars/icon.png" />

          <Typography component="h1" variant="h3" align="center" gutterBottom>
            LOGIN
          </Typography>
          <Typography component="h2" variant="body1" align="center">
            Sign in to your account to continue
          </Typography>

          <CustomerUser
            setEmail={setEmail}
            setOtp={setOtp}
            setVerification={setVerification}
            setState={setState}
          />
        </Wrapper>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Wrapper>
          <Helmet title="Alpha Plus" />
          <BigAvatar alt="alpha_plus" src="/static/img/avatars/icon.png" />
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            OTP SENT TO REGISTERED MOBILE NUMBER
          </Typography>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Enter the OTP
          </Typography>
          <OTP
            email={email}
            type="customer_user"
            otp={otp}
            setOtp={setOtp}
            verification={verification}
          />
        </Wrapper>
      </React.Fragment>
    );
  }
}

export default Login;
